import { ARRIVAL_ALERT_BOUNDS, DEFAULT_ARRIVAL_ESTIMATE, arrivalEstimateIssue, copyArrivalEstimate } from './arrival-alert-policy.js';
import { hasExactly, intWithin, isPlainRecord, marketRuleSetting, resolveMarketRule } from './market-rule-kit.js';
export const ARRIVING_SOON_KEY = 'notification.arrivingSoon';
export const ARRIVING_SOON_BOUNDS = {
    withinMeters: ARRIVAL_ALERT_BOUNDS.withinMeters,
    withinSeconds: ARRIVAL_ALERT_BOUNDS.withinSeconds,
    minSecondsAfterStart: { min: 0, max: 600 },
};
export const DEFAULT_ARRIVING_SOON = { enabled: true, withinMeters: 300, withinSeconds: 60, minSecondsAfterStart: 30, estimate: DEFAULT_ARRIVAL_ESTIMATE };
export const STRICT_ARRIVING_SOON = {
    enabled: false,
    withinMeters: ARRIVING_SOON_BOUNDS.withinMeters.min,
    withinSeconds: ARRIVING_SOON_BOUNDS.withinSeconds.min,
    minSecondsAfterStart: ARRIVING_SOON_BOUNDS.minSecondsAfterStart.max,
    estimate: DEFAULT_ARRIVAL_ESTIMATE,
};
export const ARRIVING_SOON_REASON_CODES = ['ARRIVING_SOON_GOVERNED', 'ARRIVING_SOON_DEFAULT', 'ARRIVING_SOON_INVALID'];
const MEMBERS = ['enabled', 'withinMeters', 'withinSeconds', 'minSecondsAfterStart', 'estimate'];
export function arrivingSoonIssue(v) {
    if (!isPlainRecord(v))
        return 'NOT_AN_OBJECT';
    if (!hasExactly(v, MEMBERS))
        return 'UNKNOWN_OR_MISSING_MEMBER';
    const b = ARRIVING_SOON_BOUNDS;
    if (typeof v.enabled !== 'boolean')
        return 'INVALID_ENABLED';
    if (!intWithin(v.withinMeters, b.withinMeters.min, b.withinMeters.max))
        return 'INVALID_WITHIN_METERS';
    if (!intWithin(v.withinSeconds, b.withinSeconds.min, b.withinSeconds.max))
        return 'INVALID_WITHIN_SECONDS';
    if (!intWithin(v.minSecondsAfterStart, b.minSecondsAfterStart.min, b.minSecondsAfterStart.max))
        return 'INVALID_MIN_SECONDS_AFTER_START';
    return arrivalEstimateIssue(v.estimate);
}
export const ARRIVING_SOON_SPEC = {
    key: ARRIVING_SOON_KEY,
    issue: arrivingSoonIssue,
    copy: (v) => ({ enabled: v.enabled, withinMeters: v.withinMeters, withinSeconds: v.withinSeconds, minSecondsAfterStart: v.minSecondsAfterStart, estimate: copyArrivalEstimate(v.estimate) }),
    defaultValue: DEFAULT_ARRIVING_SOON,
    strictValue: STRICT_ARRIVING_SOON,
    reasonPrefix: 'ARRIVING_SOON',
};
export function arrivingSoonSetting(input) {
    return marketRuleSetting(ARRIVING_SOON_SPEC, input);
}
export function resolveArrivingSoon(settings, marketId, at, regionCode) {
    return resolveMarketRule(ARRIVING_SOON_SPEC, settings, marketId, at, regionCode);
}
export function arrivingSoonWire(decision) {
    return { enabled: decision.value.enabled, withinMeters: decision.value.withinMeters, withinSeconds: decision.value.withinSeconds, policyVersion: decision.policyVersion };
}
//# sourceMappingURL=arriving-soon-policy.js.map